import { css } from '@emotion/react'
import { useState, useEffect, useCallback } from 'react'
import { inject, observer } from 'mobx-react'
import _ from 'lodash'
import { Container } from './styles'
import { withRouterProps } from '../../utils'
import useHomeLifecycle from './useHomeLifecycle'
import Intro from './Intro'
import IncomeGoal from './IncomeGoal'
import EmployerPlanAccount from './EmployerPlanAccount'
import HomeActions from './HomeActions'

import { Drawer, PageLoading } from '../../components'
import UnderstandingYourResults from '../spend-down/understanding-your-results/UnderstandingYourResults'
import { HomeHeyNicBubble } from '../hey-nic'

const mode = 'spending'

function SpendDownHome(props) {
  const {
    navigate,
    main: { sidebarActive, toggleSidebar, expandSidebar },
    store: {
      getBaseAdvicesForSpending,
      allSpendingRecommendedCases,
      getRecommendedAdvicesForSpending,
      spendingRecommendedCases,
      getBaseCase,
      recommendedCase,
      getRecommendedCase,
      getSurvivorPension,
      config: { onBoarded, spendDownModeling, disableSpendDownModeling },
      auth: { hasStripeSessionId, retailLinkAccount, deleteStripeSessionId },
    },
  } = props
  const [status, setStatus] = useState('loading')
  const [drawer, setDrawer] = useState('')

  const handleCancel = useCallback(() => setDrawer(''), [setDrawer])

  useHomeLifecycle({
    navigate,
    onBoarded,
    spendDownModeling,
    disableSpendDownModeling,
    hasStripeSessionId,
    retailLinkAccount,
    deleteStripeSessionId,
    sidebarActive,
    toggleSidebar,
    expandSidebar,
  })

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getBaseCase()
        if (_.isEmpty(recommendedCase)) {
          await getRecommendedCase()
        }
        await getSurvivorPension()
        await getBaseAdvicesForSpending()
        if (_.isEmpty(spendingRecommendedCases)) {
          await getRecommendedAdvicesForSpending()
        }
        setStatus('success')
      } catch (err) {
        setStatus('error')
        console.error(err)
      }
    }

    fetchData()
  }, [
    getBaseAdvicesForSpending,
    getBaseCase,
    getRecommendedAdvicesForSpending,
    getRecommendedCase,
    getSurvivorPension,
    recommendedCase,
    spendingRecommendedCases,
  ])

  if (status === 'error') {
    return (
      <div
        css={css`
          color: #e31e27;
          font-size: 14px;
          line-height: 1.5;
          text-align: center;
          padding: 0.25rem 0 0.75rem 0;
        `}>
        Something went wrong, please try again later.
      </div>
    )
  }

  return status === 'success' ? (
    <Container>
      <Intro mode={mode} />
      <IncomeGoal mode={mode} />
      <EmployerPlanAccount
        allSpendingRecommendedCases={allSpendingRecommendedCases}
        mode={mode}
        setDrawer={setDrawer}
      />
      <HomeActions mode={mode} />
      <HomeHeyNicBubble />
      <Drawer active={drawer === 'Personalized Help'} width='100%'>
        <UnderstandingYourResults
          setDrawer={setDrawer}
          handleCancel={handleCancel}
          openedFromHome
        />
      </Drawer>
    </Container>
  ) : (
    <PageLoading />
  )
}

export default withRouterProps(inject('store', 'main')(observer(SpendDownHome)))
